import React from "react";
import {
  Typography,
  Chip,
  ButtonDS,
  Price,
} from "get-life-storybook-ts";
import { ChipI } from "get-life-storybook-ts/lib/atoms/Chip/Chip";

interface PriceData {
  price: string;
  priceLabel: string;
  decimals: string;
  frequency?: string;
  after?: string;
  PromoOnClick?: () => void;
}

interface PriceSummaryCardProps {
  titlePrice?: string;
  price: PriceData;
  tags: ChipI[];
  buttonText: string;
  onClick: () => void;
  priceChange?: boolean;
  subtitle?: string;
  tooltipText?: React.ReactNode;
  trustpilot?: string;
  showTrustpilot?: boolean;
  cancelAnytimeText?: string;
}

const PriceSummaryCard: React.FC<PriceSummaryCardProps> = ({
  titlePrice,
  price,
  tags,
  buttonText,
  onClick,
  priceChange = false,
  subtitle,
  tooltipText,
  trustpilot,
  showTrustpilot,
  cancelAnytimeText,
}) => {
  return (
    <div className="flex flex-col justify-start items-center bg-white w-full py-[20px] md:py-[24px] gap-y-[24px]">
      {titlePrice && (
        <Typography
          variant="H3"
          weight="700"
          text={titlePrice}
          color="gray-text"
          className="text-[#424242] text-[22px]"
        />
      )}

      <div className="flex flex-col items-center gap-[6px] text-center">
        <Price loading={priceChange} {...price} />
        {cancelAnytimeText && (
          <i className="text-[#686868] text-[14px] leading-[1.4]">
            {cancelAnytimeText}
          </i>
        )}
      </div>

      <div className="flex flex-row gap-[10px] items-center justify-center px-[24px] flex-wrap">
        {tags.map((tag, idx) => (
          <Chip
            key={`${tag.text}_${idx}`}
            text={tag.text}
            type="success"
            icon="CheckedIcon"
          />
        ))}
      </div>

      {subtitle && (
        <Typography variant="BodySmall" weight="400" text={subtitle} />
      )}

      {tooltipText && (
        <div className="text-center text-sm text-gray-500">
          {tooltipText}
        </div>
      )}

      <div className="w-full max-w-[325px]">
        <ButtonDS
          label={buttonText}
          onClick={onClick}
          rightIcon="ArrowRightIcon"
          className="w-full"
        />
      </div>

      {showTrustpilot && trustpilot && (
        <div className="flex flex-col items-center px-[16px]">
          <span
            className="BodyS font-normal text-[#686868] block text-center max-w-[300px] md:max-w-none"
            dangerouslySetInnerHTML={{ __html: trustpilot }}
          />
        </div>
      )}
    </div>
  );
};

export default PriceSummaryCard;
